import { createRouter, createWebHistory } from 'vue-router';

// Importar las vistas con los nombres correctos
import AvisoDePrivacidad from '../views/AvisoDePrivacidad.vue';
import BeneficiosPage from '../views/BeneficiosPage.vue';
import BlogGrid from '../views/BlogGrid.vue';
import BlogPost from '../views/BlogPost.vue';
import CapacitacionPage from '../views/CapacitacionPage.vue';
import CasosDeExito from '../views/CasosDeExito.vue';
import ConsultoriaYAsesoriaDeIngenieria from '../views/ConsultoriaYAsesoriaDeIngenieria.vue';
import ContactoPage from '../views/ContactoPage.vue';
import ErrorPage404 from '../views/ErrorPage404.vue';
import Industria4_0 from '../views/Industria4_0.vue';
import IngenieriaDeProceso from '../views/IngenieriaDeProceso.vue';
import InicioPage from '../views/InicioPage.vue';
import ITDesarrolloDeSoftware from '../views/ITDesarrolloDeSoftware.vue';
import NosotrosPage from '../views/NosotrosPage.vue';
import PoliticasDeCookies from '../views/PoliticasDeCookies.vue';
import ServiciosPage from '../views/ServiciosPage.vue';
import TerminosYCondiciones from '../views/TerminosYCondiciones.vue';
import AutomatizacionDeControl from '../views/AutomatizacionDeControl.vue';
import CursoDetalle from '../views/CursoDetalle.vue'; // <-- Agregado para detalle de cursos

const routes = [
  { path: '/', component: InicioPage },
  { path: '/nosotros', component: NosotrosPage },
  { path: '/beneficios', component: BeneficiosPage },
  { path: '/blog', component: BlogGrid, name: 'BlogGrid' }, // Ruta nombrada para grid
  { path: '/blog/:slug', component: BlogPost, name: 'BlogPost' }, // Ruta nombrada para posts
  { path: '/capacitacion', component: CapacitacionPage },
  { path: '/capacitacion/:slug', component: CursoDetalle, name: 'CursoDetalle' }, // <-- Agregada esta línea
  { path: '/casosdeexito', component: CasosDeExito },
  { path: '/consultoria-asesoria-ingenieria', component: ConsultoriaYAsesoriaDeIngenieria },
  { path: '/contacto', component: ContactoPage },
  { path: '/error-404', component: ErrorPage404 },
  { path: '/industria-4-0', component: Industria4_0 },
  { path: '/ingenieria-de-proceso', component: IngenieriaDeProceso },
  { path: '/it-desarrollo-software', component: ITDesarrolloDeSoftware },
  { path: '/politicas-cookies', component: PoliticasDeCookies },
  { path: '/servicios', component: ServiciosPage },
  { path: '/aviso-privacidad', component: AvisoDePrivacidad },
  { path: '/terminos-condiciones', component: TerminosYCondiciones },
  { path: '/automatizacion-de-control', component: AutomatizacionDeControl },
  {
      path: '/:pathMatch(.*)*',
      redirect: '/error-404'
    }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si el usuario usa atrás/adelante, respeta la posición anterior
    if (savedPosition) return savedPosition;

    // Si hay hash (#seccion), scrollea al elemento con offset por navbar sticky
    if (to.hash) {
      return {
        el: to.hash,
        top: 100,          // ajusta este valor a la altura real de tu navbar
        behavior: 'smooth' // quítalo si no quieres animación
      };
    }

    // Navegación normal: ir al tope
    return { left: 0, top: 0 };
  }
});

export default router;
